const React = require("react");

const rawLanguages = require("../../i18n/config.json");

const languages = Array.isArray(rawLanguages) ? rawLanguages : [];
const defaultLanguage = languages[0] || {};
const languageMap = new Map(
  languages.map((entry) => [String(entry.code || "").toLowerCase(), entry])
);

const getLanguageEntry = (code) => {
  const normalized = String(code || "").toLowerCase();
  return languageMap.get(normalized) || defaultLanguage;
};

const computeAttributes = (pageContext = {}) => {
  const langCode =
    pageContext?.i18n?.language || pageContext?.language || defaultLanguage.code;

  const entry = getLanguageEntry(langCode);
  const langAttr =
    pageContext?.htmlLang || entry?.hrefLang || entry?.code || "en";
  const dirAttr =
    pageContext?.i18n?.langDir || entry?.langDir || "ltr";

  return {
    lang: langAttr,
    dir: dirAttr,
  };
};

const applyHtmlAttributes = ({ lang, dir }) => {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  if (!root) return;

  if (lang) {
    root.setAttribute("lang", lang);
  }
  if (dir) {
    root.setAttribute("dir", dir);
  }
};

const LanguageAttributes = ({ pageContext, children }) => {
  const attrs = computeAttributes(pageContext);

  React.useEffect(() => {
    applyHtmlAttributes(attrs);
  }, [attrs.lang, attrs.dir]);

  return children;
};

LanguageAttributes.defaultProps = {
  pageContext: {},
};

module.exports = {
  LanguageAttributes,
  computeLanguageAttributes: computeAttributes,
  languageEntries: languages,
  defaultLanguage,
};
